function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9 10c-2.84 0-5.143-2.238-5.143-5S6.16 0 9 0s5.143 2.238 5.143 5S11.84 10 9 10zm3.6 1.25c2.981 0 5.4 2.352 5.4 5.25v1.625C18 19.16 17.136 20 16.071 20H1.93C.864 20 0 19.16 0 18.125V16.5c0-2.898 2.419-5.25 5.4-5.25h.671a7.184 7.184 0 005.858 0h.671z"
});

var SvgPersonIcon = function SvgPersonIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 20"
  }, props), _ref);
};

export default SvgPersonIcon;